import * as types from "./types";

export const getCompanyWorkingLogsRequest = (payload) => ({
  type: types.GET_COMPANY_WORKING_LOGS_REQUEST,
  payload,
});

export const getCompanyWorkingLogsResponse = (payload) => ({
  type: types.GET_COMPANY_WORKING_LOGS_RESPONSE,
  payload,
});

export const getCompanyWorkingSlotsRequest = (payload) => ({
  type: types.GET_COMPANY_WORKING_SLOTS_REQUEST,
  payload,
});

export const getCompanyWorkingSlotsResponse = (payload) => ({
  type: types.GET_COMPANY_WORKING_SLOTS_RESPONSE,
  payload,
});

export const addCompanyWorkingSlot = (payload) => ({
  type: types.ADD_COMPANY_WORKING_SLOT,
  payload,
});

export const editCompanyWorkingSlotRequest = (payload) => ({
  type: types.EDIT_COMPANY_WORKING_SLOT_REQUEST,
  payload,
});

export const deleteCompanyWorkingSlotRequest = (payload) => ({
  type: types.DELETE_COMPANY_WORKING_SLOT_REQUEST,
  payload,
});

export const getCompanyTrainingWorkingSlotsRequest = (payload) => ({
  type: types.GET_COMPANY_TRAINING_WORKING_SLOTS_REQUEST,
  payload,
});

export const getCompanyTrainingWorkingSlotsResponse = (payload) => ({
  type: types.GET_COMPANY_TRAINING_WORKING_SLOTS_RESPONSE,
  payload,
});

export const addCompanyTrainingWorkingSlot = (payload) => ({
  type: types.ADD_COMPANY_TRAINING_WORKING_SLOT,
  payload,
});

export const editCompanyTrainingWorkingSlotRequest = (payload) => ({
  type: types.EDIT_COMPANY_TRAINING_WORKING_SLOT_REQUEST,
  payload,
});

export const deleteCompanyTrainingWorkingSlotRequest = (payload) => ({
  type: types.DELETE_COMPANY_TRAINING_WORKING_SLOT_REQUEST,
  payload,
});
